export const FILE_EXT_ICON_MAP = {
    pdf: 'pdf',
    doc: 'word',
    docx: 'word',
    xls: 'xls',
    xlsx: 'xls',
    ppt: 'ppt',
    pptx: 'ppt',
    txt: 'txt',
    html: 'link',
    htm: 'link',
    md: 'md',
    markdown: 'md',
    jpg: 'png',
    jpeg: 'png',
    png: 'png',
    gif: 'png',
    bmp: 'png',
    webp: 'png',
    mp4: 'video',
    mov: 'video',
    avi: 'video',
    mkv: 'video',
    wmv: 'video',
    mp3: 'radio',
    wav: 'radio',
    aac: 'radio',
    flac: 'radio',
    m4a: 'radio',
} as const;

export type FileIconName = (typeof FILE_EXT_ICON_MAP)[keyof typeof FILE_EXT_ICON_MAP];
